const brandsData = [
    {
      id: 1,
      name: "Nike",
      description: "Nike is a multinational corporation that designs, develops, manufactures, and markets footwear, apparel, equipment, accessories, and services.",
      image: "https://via.placeholder.com/150",
    },
    {
      id: 2,
      name: "Samsung",
      description: "Samsung is a South Korean multinational conglomerate headquartered in Seoul. It comprises numerous affiliated businesses, most of them united under the Samsung brand.",
      image: "https://via.placeholder.com/150",
    },
    {
      id: 3,
      name: "Apple",
      description: "Apple Inc. is an American multinational technology company that designs, develops, and sells consumer electronics, computer software, and online services.",
      image: "https://via.placeholder.com/150",
    },
    {
      id: 4,
      name: "Intel",
      description: "Intel Corporation is an American multinational corporation and technology company headquartered in Santa Clara, California.",
      image: "https://via.placeholder.com/150",
    },
    {
      id: 5,
      name: "Nvidia",
      description: "Nvidia Corporation is an American multinational technology company incorporated in Delaware and based in Santa Clara, California.",
      image: "https://via.placeholder.com/150",
    },
  ];
  
  export default brandsData;
  